import React from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useContext } from "react";
import { AppContext } from "../../context/AppProvider";
import { useMutation } from "@tanstack/react-query";
import { deleteCommitment } from "../../api/commitmentsAPI";
import { getErrorMessage } from "../../util/helper";
import { queryClient } from "../../api/requestProcessor";

const DeleteCommitmentDialog = ({
  visible,
  setVisible,
  commitment,
  onHide,
}) => {
  const { toast } = useContext(AppContext);

  const { mutate: deleteCommitmentMutation, isPending } = useMutation({
    mutationFn: deleteCommitment,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["commitments"] });
      toast.current.show({
        severity: "success",
        summary: "Successful",
        detail: "Commitment Deleted",
        life: 3000,
      });
      onHide();
    },
    onError: (error) => {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: getErrorMessage(error),
        life: 3000,
      });
    },
  });

  const handleDelete = () => {
    if (commitment?._id) {
      deleteCommitmentMutation(commitment._id);
    }
  };

  const footerContent = (
    <div>
      <Button
        label="No"
        icon="pi pi-times"
        outlined
        onClick={onHide}
        className="mr-2"
      />
      <Button
        label="Yes"
        icon="pi pi-check"
        severity="danger"
        onClick={handleDelete}
        loading={isPending}
      />
    </div>
  );

  return (
    <Dialog
      visible={visible}
      style={{ width: "32rem" }}
      breakpoints={{ "960px": "75vw", "641px": "90vw" }}
      header="Confirm Delete"
      modal
      footer={footerContent}
      onHide={onHide}
    >
      <div className="flex align-items-center">
        <i
          className="pi pi-exclamation-triangle flex-shrink-0"
          style={{
            fontSize: "2rem",
            color: "var(--red-500)",
            marginRight: "1rem",
          }}
        />
        <span className="flex-grow-1">
          Are you sure you want to delete the commitment{" "}
          <b>{commitment?.title}</b>?
        </span>
      </div>
    </Dialog>
  );
};

export default DeleteCommitmentDialog;
